import React from "react";
import { useState, useEffect } from "react";
import SortedHeader from "../../../../components/Tables/SortedHeader";
import { DOCOnlineService } from "../../../../services/DOCOnlineService";

import { useTranslation } from "react-i18next";
import SideDrawerSearch, {
  useSideDrawerSearch
} from "../../../../components/SideDrawerSearch";
import ConversationIcon from "../../../../layout/left_menu_icons/conversation.svg";
import Pagination from "../../../../components/Pagination";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import DocOnlineListFilter from "./DocOnlineListFilters";

export default function DocOnlineList() {
  const [docs, setDocs] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const [searchObject, setSearchObject] = useState({
    orderBy: "CreatedAt",
    order: 1
  });
  const [totalPages, setTotalPages] = useState(0);
  const history = useHistory();
  let { t } = useTranslation();

  const [headers, setHeaders] = useState([
    { label: t("Name"), field: "Name" },
    { label: t("Job Role"), field: "JobRoleId" },
    { label: t("years of experience"), field: "Yearsofexperience" },
    { label: t("Mobile number"), field: "PhoneNumber" }
  ]);
  useEffect(() => {
    getDocs();
  }, [pageSize, pageNumber]);

  function getDocs() {
    DOCOnlineService.getDocs(pageSize, pageNumber, searchObject).then((res) => {
      setTotalPages(Math.ceil(res.total / pageSize));
      setDocs(res.page);
    });
  }

  function searchForm() {
    return (
      <DocOnlineListFilter
        searchObject={searchObject}
        setSearchObject={setSearchObject}
      />
    );
  }

  return (
    <>
      <div className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={ConversationIcon} alt="ni-icon" />
            <h1 style={{ marginTop: "10px" }}>{t("Doconline")}</h1>
          </div>
          <div className="subtitle">{t("Doconline")}</div>
        </div>
      </div>
      <SideDrawerSearch
        searchObject={searchObject}
        setSearchObject={setSearchObject}
        searchForm={searchForm}
        onClearFilters={() =>
          setSearchObject({ orderBy: "CreatedAt", order: 1, jobRoleId: "" })
        }
        submitSearch={getDocs}
      >
        <div className="table-wrap">
          <table className="table-responsive">
            <thead>
              {" "}
              <SortedHeader
                searchObject={searchObject}
                headers={headers}
                setHeaders={setHeaders}
                setSearchObject={setSearchObject}
              />
            </thead>

            <tbody>
              {docs.map((doc) => (
                <tr
                  key={doc.id}
                  onClick={() =>
                    window.open(`/interviews/DOCEdit/${doc.id}`).focus()
                  }
                >
                  <td>{doc.name}</td>
                  <td>{doc.jobRole}</td>
                  <td>{doc.yearsOfExperience}</td>
                  <td>{doc.mobileNumber}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="row mt-5">
            <Pagination
              totalPages={totalPages}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </SideDrawerSearch>{" "}
    </>
  );
}
